const SORT ={
    "ASC":"ascending",
    "DSC":"descending"
}

export {
    SORT
}